import sdl from '@jds/react-generated-sdl/JDSSearchBox';
import type { JDSSearchBoxProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SearchBoxProps } from '../logic';

const Component = (props: SearchBoxProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'normal',
    disabled = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, disabled, ariaLabel, ...rest },
    'JDSSearchBox',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SearchBox = withLogic(Component) as React.FC<SearchBoxProps> & {
  slotName?: string;
};

SearchBox.displayName = 'SearchBox';
SearchBox.slotName = 'jds_search_box';

export { SearchBox, type JDSSearchBoxProps };
